import { createContext, useContext, useMemo, useReducer } from "react";

export const ModalContext = createContext();

const reducer = (state, action) => {
    switch (action.type) {
        case 'openProfileModal':
            return {
                modalType: "profile",
            }
        case 'openWShareWishesListModal':
            return {
                modalType: "shareList",
            }
        case 'openWishDataModal':
            return {
                modalType: "wishData",
                wishData: action.payload,
            }
        case 'openAddWishModal':
            return {
                modalType: "addWish",
            }
        case 'editModal':
            return {
                modalType: action.payload[0],
                editModalData: true,
                wishData: action.payload[1],
            }
        case 'closeModal':
            return {
                modalType: "",
                editModalData: false,
                wishData: null,
            }
        default:
            throw new Error('Action non supportée')
    }
}

const ModalContextProvider = (props) => {

    const [modalState, modalDispatch] = useReducer(reducer, {
        modalType: "",
        editModalData: false,
        wishData: null,
    })

    const openProfileModal = () => modalDispatch({ type: 'openProfileModal' })
    const openWShareWishesListModal = () => modalDispatch({ type: 'openWShareWishesListModal' })
    const openWishDataModal = (wishData = null) => {
        modalDispatch({
            type: 'openWishDataModal',
            payload: wishData,
        })
    }
    const openAddWishModal = () => modalDispatch({ type: 'openAddWishModal' })
    const editModal = () => {
        modalDispatch({
            type: 'editModal',
            payload: [modalState.modalType, modalState.wishData]
        })
    }
    const closeModal = () => modalDispatch({ type: 'closeModal' })

    const values = useMemo(
        () => ({
            modalState, modalDispatch,
            openProfileModal,
            openWShareWishesListModal,
            openWishDataModal,
            openAddWishModal,
            editModal,
            closeModal,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [modalState]
    );

    return <ModalContext.Provider value={values} {...props} />;
};
export default ModalContextProvider;

export const useModalContext = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error(
            "useModalContext doit être utilisé dans le context adéquat"
        );
    }

    return context;
};